module.exports = __webpack_public_path__ + "img/picture_bms2.fe77e165.jpg";